document.addEventListener('DOMContentLoaded', function() {
  // Only add occasions button on mobile for card collections
  if (window.innerWidth <= 989) {
    addOccasionsButton();
  }
  
  // Handle window resize
  window.addEventListener('resize', function() {
    if (window.innerWidth <= 989 && !document.getElementById('mobileOccasionsBtn')) {
      addOccasionsButton();
    } else if (window.innerWidth > 989) {
      const occasionsBtn = document.getElementById('mobileOccasionsBtn');
      if (occasionsBtn) {
        occasionsBtn.remove();
      }
    }
  });
  
  function addOccasionsButton() {
    const mobileFacetsWrapper = document.querySelector('.mobile-facets__wrapper');
    
    if (mobileFacetsWrapper && !document.getElementById('mobileOccasionsBtn')) {
      // Create occasions button with more compact styling
      const occasionsBtn = document.createElement('button');
      occasionsBtn.id = 'mobileOccasionsBtn';
      occasionsBtn.className = 'mobile-occasions-btn';
      occasionsBtn.setAttribute('aria-label', 'Browse occasions');
      occasionsBtn.innerHTML = `
        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M6 2V6M14 2V6M3 10H17M5 4H15C16.1046 4 17 4.89543 17 6V16C17 17.1046 16.1046 18 15 18H5C3.89543 18 3 17.1046 3 16V6C3 4.89543 3.89543 4 5 4Z"/>
        </svg>
        <span class="mobile-facets__open-label">Occasions</span>
      `;
      
      // Insert at the beginning of the wrapper
      mobileFacetsWrapper.insertBefore(occasionsBtn, mobileFacetsWrapper.firstChild);
      
      // Add click handler to open hamburger menu
      occasionsBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Find and trigger the hamburger menu button
        const headerMenuBtn = document.querySelector('.header__actions_btn--menu');
        if (headerMenuBtn) {
          headerMenuBtn.click();
        }
      });
    }
  }
});